// @vue/component
export default {
  name: 'SinglePackageItem',

  props: {
    // the typo is intentional. The word 'package' is reserved in JS
    packagee: {
      type: Object,
      default: () => ({}),
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    isOnPromotion: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isWaitingForRedirectToPayments: false,
    };
  },

  computed: {
    packageExtensions() {
      return this.packagee.includes ? this.packagee.includes.split(',') : [];
    },
    promotionCode() {
      return this.$store.getters['promotionCodes/one'][0];
    },
    price() {
      if (!this.isOnPromotion || this.promotionCode.type === 'amount') return this.packagee.price;
      return (this.packagee.price - ((this.promotionCode.value / 100) * this.packagee.price)).toFixed(2);
    },
    amount() {
      if (!this.isOnPromotion || this.promotionCode.type === 'percent') return this.packagee.number_of_connections;
      return this.packagee.number_of_connections + this.promotionCode.value;
    },
  },

  methods: {
    handleSelectPackage() {
      this.$emit('selectedPackage', this.packagee);
    },
  },
};
